<div class="radio-wrapper" *ngIf="this.techStackData?.runtime !== 'GAE first Generation'">
    <div *ngFor="let option of possibleValues" class="field-radiobutton mb-1">
        <p-radiobutton [name]="property.name" [(ngModel)]="searchValue" [value]="option.value" [inputId]="option.value"
            [disabled]="disableField" (onClick)="valueChange($event)"></p-radiobutton>
        <label class="mb-0 ml-1 mr-2" [for]="option.value">{{option.name}}</label>
    </div>
</div>
<p-select [showClear]="true" [options]="possibleValues"
    [class.remove-clear]="defaultValue ? defaultValue === searchValue : false" optionLabel="name" optionValue="value"
    appendTo="body" [(ngModel)]="searchValue" class="form-control form-control-sm" placeholder="Select"
    [disabled]="disableField" *ngIf="this.techStackData?.runtime === 'GAE first Generation'"
    (onChange)="valueChange($event)">
    <ng-template let-possibleValue pTemplate="item">
        <div class="value-item" [ngClass]="possibleValue.value">
            <div>{{possibleValue.name}}</div>
        </div>
    </ng-template>
</p-select>